import { useContext } from "react";
import ThemeContext from "~/contexts/ThemeContext";

const CircleBackButton = () => {
  const { template } = useContext(ThemeContext);

  // Styles
  const color = template.global.icon.colour;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1685_57077)">
        <path
          d="M16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 5.13895e-07 8 6.99382e-07C5.87827 8.8487e-07 3.84343 0.842856 2.34314 2.34315C0.842853 3.84344 -8.8487e-07 5.87827 -6.99382e-07 8C-5.13895e-07 10.1217 0.842854 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8ZM7.21875 3.96875C7.5125 3.675 7.9875 3.675 8.27812 3.96875C8.56875 4.2625 8.57187 4.7375 8.27812 5.02813L6.05937 7.24688L11.75 7.25C12.1656 7.25 12.5 7.58438 12.5 8C12.5 8.41563 12.1656 8.75 11.75 8.75L6.05937 8.75L8.27812 10.9688C8.57187 11.2625 8.57187 11.7375 8.27812 12.0281C7.98437 12.3188 7.50937 12.3219 7.21875 12.0281L3.71875 8.53125C3.425 8.2375 3.425 7.7625 3.71875 7.47188L7.21875 3.96875Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1685_57077">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(16 16) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircleBackButton;
